import React, { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { Button } from '@mui/material';

const Results = ({ movieData }) => {
  const [expanded, setExpanded] = useState(movieData[0]?.title || false);

  const handleChange = (panel) => (_, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
      {movieData.map((item) => (
        <Accordion
          key={item.title}
          expanded={expanded === item.title}
          onChange={handleChange(item.title)}
        >
          <AccordionSummary
            expandIcon={<ArrowDownwardIcon />}
            aria-controls="panel-content"
            id="panel-header"
          >
            <Typography component="span">
              <strong>{item.title}</strong>
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ textAlign: 'left' }}>
            <Typography style={{ display: 'flex', justifyContent: 'left' }}>
            <img
  style={{
    width: '100px',
    height: '150px',
    objectFit: 'cover',
    borderRadius: '4px',
    marginRight: '15px'
  }}
  alt={item.title}
  src={item.poster}
/>{' '}
              {item.overview}
            </Typography>
            <div style={{ width: '100%', marginTop: '20px' }}>
              <Button
                href={item.previewLink}
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
              >
                Click here to preview
              </Button>
            </div>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default Results;
